<template>
    <div class="page-grid-wrapper">
        <div class="page-grid-fix" v-if="!isLoadingJewellery" style="padding-bottom: 55px;">
                <h2>You may also like</h2>
            <div class="jewelleryes bordered">
                <div class="grid-view">                           
                    <div v-for="variant in variants" class="grid-item jewellery__card" ref="card">
                        <router-link :to="{ name: 'jewellerycard', params: { jewellerySKU: variant.SKU }}">
                            <figure class="image-container">
                                    <img class="imageGridSource" :src="'/jewelries/gallery/NJ-' + variant.SKU + '/grid-image/custom_grid_image_NJ-' + variant.SKU + '.jpg'" alt="" :key="variant.SKU" @error="handleImagePlaceholder">
                                    <img class="alternativeImageGridSource" @error="imageLoadError" :src="'/jewelries/gallery/NJ-' + variant.SKU + '/grid-image/main_grid_image_NJ-' + variant.SKU + '.jpg'" alt="">
                                <figcaption>
                                    <p>{{ variant.Name }}</p>
                                </figcaption>
                            </figure>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JewelleryVariants',
    props: {
        manufacturername: String,
        sku: String,
    },

    data() {
        return {
            jewelries: [],
            jewellery: {},
            variant: '',
            isLoadingJewellery: true, // Add a loading state
        };
    },
    mounted() {
        this.getJewelries();
    },
    methods: {
        imageLoadError(event) {
            event.target.parentNode.removeChild(event.target); // Remove the image from the DOM
        },
        handleImagePlaceholder(event) {
            // Set the src to the placeholder image if the original image fails to load
            event.target.src = '/watches/gallery/maintenance/grid_placeholder.png';
        },
        getJewelries(address) {
            this.isLoadingJewellery = true; 
            this.$axios.get(address ? address : "/api/jewelriesall" ).then(response => {
               this.jewelries = response.data.data;
               this.isLoadingJewellery = false;
             });
           },

    },
    computed: {
        variants() {
            this.jewelries.sort((a, b) => {
                return Math.random() - 0.5;
            });
            const filteredJewelries = this.jewelries.filter((jewellery) => {
                return jewellery.SKU !== this.sku && jewellery.ManufacturerName === this.manufacturername;
            }).slice(0, 3);
            const uniqueSKUs = new Set(filteredJewelries.map((jewellery) => jewellery.SKU));
            while (uniqueSKUs.size < 3) {
                const jewelleryToAdd = this.jewelries.find((jewellery) => {
                    return jewellery.SKU !== this.sku && !uniqueSKUs.has(jewellery.SKU);
                });
                if (!jewelleryToAdd) {
                    break;
                }
                filteredJewelries.push(jewelleryToAdd);
                uniqueSKUs.add(jewelleryToAdd.SKU);
            }
            return [filteredJewelries[0], ...filteredJewelries.slice(1)];
        }
    }
}
</script>